
import { store } from "../store/store.js";
import { alertas } from "../ui/alerts.js";
import { loginUser, forgotPassword } from "../api/api.js";
import { ValidateEmail } from "../utils/helpers.js";



export function top_section_index(){

document.getElementById("top_banner_index").innerHTML =`
        <div class="banner-inner">
  <div style="position: absolute;
background: -moz-linear-gradient(left, rgba(0, 70, 140, 0.5) 0%, rgba(64, 224, 208, 0.5) 100%);
background: -webkit-linear-gradient(left, rgba(0, 70, 140, 0.5) 0%, rgba(64, 224, 208, 0.5) 100%);
background: linear-gradient(to right, rgba(0, 70, 140, 0.5) 0%, rgba(64, 224, 208, 0.5) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8000468c', endColorstr='#8040e0d0', GradientType=1);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;">   
    </div>
            <div class="container">
                <div class="row" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-content">
                            <br>
                            <h1>
                                Cozumel Coral<span> Reef Maps</span>
                            </h1>
                            <br>
                            <h3  style="padding-bottom: 0px;">Visit the reef <br>before you dive it! <br><span style="color:orange; font-size: 22px;font-family: Trirong;"> The reef begins before the dive!</span></h3>

                            <br>
                            <div class="store-section">
                                <a href="https://cozumel-reef-maps.com.mx/Dashboard/register" class="btn plan-btn" style="margin-top:0px; background-color: #f98228;">
                                Start Now! <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/3d_icon.png" alt="Google Play" style="height: 60px;width: 60px;">
                               </a>
                            </div>
                            <br><br>
                        </div>
                    </div>
                    <div class="offset-lg-2 dis-none">
                    </div>
                    <div class="col-lg-4 dis-none">
                        <div class="mobile-section">
                            <img src="https://cozumel-reef-maps.com.mx/Views/Default/mobile_2.png" alt="Mobile" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div class="banner-footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12">
                                <div class="banner-footer-content">
                                    <p>
                                        Our coverages are:
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-6">
                                <div class="banner-footer-details">
                                    <span><i class="fa fa-star" style="color:#fdcc38;"></i></span>
                                    <p>
                                       With more than
                                    </p>
                                    <h5>
                                        43,000 linear ft of 3D renderings
                                    </h5>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-6">
                                <div class="banner-footer-details">
                                    <span><i class="fa fa-star" style="color:#fdcc38;"></i></span>
                                    <p>
                                        Total Reefs on this 1st stage:
                                    </p>
                                    <h5>
                                        17 of 33
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      <div id="sliderContainer"></div>

    `;



}















export function login(){

document.getElementById("content_general").innerHTML = `

<a href="https://cozumel-reef-maps.com.mx/"><img src="https://cozumel-reef-maps.com.mx/Views/Default/img/logo_small.png" style="width:80px;"></a><br>

       <h2 style="color:#ffffff;font-size: 18px !important;">🪸 Are you ready to see the reefs of Cozumel in 3D? <br><br>😊 <span style="font-size:16px;">Everything begins with login or registration; once logged in, you’ll be able to access all functions and maps of Cozumel Reefs</span></h2>

  <br><br>


   <button  type="button" class="btn-main" onclick="viewLogin()">
    Users
   </button>

    <br>

   <span style="color:#ffffff;">Are you a Reef Guide or Tours Promotor or Dive Shop?</span><br><br><br>

   <a style="color:#333333;" class="btn-main" href="https://cozumel-reef-maps.com.mx/Dashboard_Members/login">
    Mermbers Accounts
  </a>


`;
}



/* ===================== VISTAS ===================== */

export function viewLogin(){

document.getElementById("content_general").innerHTML = `

  <div style="text-align:left">
  <a onclick="login()">◀ Back</a>
</div>


<a href="https://cozumel-reef-maps.com.mx/"><img src="https://cozumel-reef-maps.com.mx/Views/Default/img/logo_small.png" style="width:80px;"></a><br>

<h2 style="color:#fff;">Login Users</h2>

<form id="loginForm">
  <div class="form-card">
    <label>Email</label>
    <input type="email" name="email" required>
  </div>

  <div class="form-card">
    <label>Password</label>
    <input type="password" name="password" required>
  </div>

  <button id="button_login" type="button" class="btn-main" onclick="loginUser(this.form, this)">
    Login
  </button>


   <button type="button" class="btn-main btn-link" onclick="viewForgot()">
    Forgot password
  </button>

  <div class="small-text" style="color:#ffffff;">--- Or ---</div>

  <a href="https://cozumel-reef-maps.com.mx/Dashboard/register" class="btn plan-btn" style="    width: 95%;
    padding: 15px 10px 15px 10px;
    text-align: center;
    -webkit-appearance: button;
    border-radius: 10px;
    font-size: 14px; background-color:#414141;">
          Create Account
      </a> 

 
</form>
`;
}




export function viewForgot(){

document.getElementById("content_general").innerHTML = `
<div style="text-align:left">
  <a onclick="viewLogin()">◀ Back</a>
</div>

<h2 style="color:#fff;">Password recovery</h2>

<form id="forgotForm">
  <div class="form-card">
    <label>Email</label>
    <input type="email" name="email" required>
  </div>

  <button type="button" class="btn-main" onclick="forgotPassword(this.form, this)">
    Send email
  </button>

  <p id="forgotMsg" class="small-text"></p>
</form>
`;
}




export function view_plans_payment(){

  return `

  <style>
    /* 🔒 estilos mínimos garantizados SOLO para este bloque */
    .plan-wrapper{
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap:12px;
      margin:20px 0;
    }

    @media (max-width:520px){
      .plan-wrapper{
        grid-template-columns:1fr;
      }
    }

    .plan-card{
      cursor:pointer;
      display:block;
    }

    /* 👉 la tarjeta full ocupa las 2 columnas */
    .plan-card.full{
      grid-column: 1 / -1;
    }

    .plan-card input{
      display:none;
    }

    .plan-content{
      display:flex;
      align-items:center;
      gap:15px;
      background:#fff;
      border-radius:14px;
      padding:16px 18px;
      border:2px solid transparent;
      box-shadow:0 6px 18px rgba(0,0,0,.08);
      transition:all .25s ease;
    }

    .plan-card:hover .plan-content{
      transform:translateY(-2px);
    }

    .plan-card input:checked + .plan-content{
      border-color:#f9cf40;
      background:#fff9dc;
      box-shadow:0 10px 25px rgba(249,207,64,.35);
    }

    .plan-logo{
      width:42px;
      height:42px;
      object-fit:contain;
    }

    .plan-text{
      display:flex;
      justify-content:space-between;
      width:100%;
      font-size:16px;
      font-weight:700;
      color:#111;
    }
  </style>

  <p style="margin:20px 0 10px;font-size:16px;font-weight:600;color:#fff;">
    Select the plan of your preference
  </p>



  <div class="plan-wrapper">

    <!-- 50% -->
    <label class="plan-card">
      <input type="radio" name="plan" value="bimestral" data-price="199">
      <div class="plan-content">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
        <div class="plan-text">
          <span>Bi-monthly</span><br>
          <span>199 MXN</span>
        </div>
      </div>
    </label>

    <!-- 50% -->
    <label class="plan-card">
      <input type="radio" name="plan" value="anual" data-price="499">
      <div class="plan-content">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
        <div class="plan-text">
          <span>Annual</span><br>
          <span>499 MXN</span>
        </div>
      </div>
    </label>

    <!-- 100% -->
    <label class="plan-card full">
      <input type="radio" name="plan" value="4years" data-price="899">
      <div class="plan-content">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
        <div class="plan-text">
          <span>4 Years</span><br>
          <span>899 MXN</span>
        </div>
      </div>
    </label>

  </div>
  `;
}



function view_css_plan(){


return `<style>
    /* 🔒 estilos mínimos garantizados SOLO para este bloque */
    .plan-wrapper{
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap:12px;
      margin:20px 0;
    }

    @media (max-width:520px){
      .plan-wrapper{
        grid-template-columns:1fr;
      }
    }

    .plan-card{
      cursor:pointer;
      display:block;
    }

    /* 👉 la tarjeta full ocupa las 2 columnas */
    .plan-card.full{
      grid-column: 1 / -1;
    }

    .plan-card input{
      display:none;
    }

    .plan-content{
      display:flex;
      align-items:center;
      gap:15px;
      background:#fff;
      border-radius:14px;
      padding:16px 18px;
      border:2px solid transparent;
      box-shadow:0 6px 18px rgba(0,0,0,.08);
      transition:all .25s ease;
    }

    .plan-card:hover .plan-content{
      transform:translateY(-2px);
    }

    .plan-card input:checked + .plan-content{
      border-color:#f9cf40;
      background:#fff9dc;
      box-shadow:0 10px 25px rgba(249,207,64,.35);
    }

    .plan-logo{
      width:42px;
      height:42px;
      object-fit:contain;
    }

    .plan-text{
      display:flex;
      justify-content:space-between;
      width:100%;
      font-size:16px;
      font-weight:700;
      color:#111;
    }
  </style>

  <p style="margin:20px 0 10px;font-size:16px;font-weight:600;color:#fff;">
    Select the plan of your preference
  </p>`;

}


function planBimestral(){
  return `
  <label class="plan-card full">
    <input type="radio" name="plan" value="bimestral" data-price="199">
    <div class="plan-content">
      <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
      <div class="plan-text">
        <span>Bi-monthly</span><br>
        <div id="usd_transform"></div>
      </div>



    </div>

    

  </label>`;
}

function planAnual(){
  return `
  <label class="plan-card full">
    <input type="radio" name="plan" value="anual" data-price="499">
    <div class="plan-content">
      <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
      <div class="plan-text">
        <span>Annual</span><br>
        <div id="usd_transform_year"></div>
      </div>

    

    </div>

    

  </label>`;
}

function plan4Years(){
  return `
  <label class="plan-card full">
    <input type="radio" name="plan" value="4years" data-price="899">
    <div class="plan-content">
      <img src="https://cozumel-reef-maps.com.mx/Views/Default/logo_small.png" class="plan-logo">
      <div class="plan-text">
        <span>4 Years</span><br>
        <div id="usd_transform_4_year"></div>
      </div>

      

    </div>

    
  </label>`;
}






export function renderPlansByPaymentsAccepted(payments_accepted) {

  switch (Number(payments_accepted)) {

    case 0:
      // 🔓 199 + 499 + 899
      return `
        ${view_css_plan()}
        ${planBimestral()}
        ${planAnual()}
        ${plan4Years()}
      `;

    case 1:
      // 🟡 solo 499
      return `
        ${view_css_plan()}
        ${planAnual()}
      `;

    case 2:
      // 🟠 199 + 499
      return `
        ${view_css_plan()}
        ${planBimestral()}
        ${planAnual()}
      `;

    case 3:
      // 🔴 solo 899
      return `
        ${view_css_plan()}
        ${plan4Years()}
      `;

    case 4:
      // 🔵 solo 199
      return `
        ${view_css_plan()}
        ${planBimestral()}
      `;

    case 5:
      // 🟣 199 + 899
      return `
        ${view_css_plan()}
        ${planBimestral()}
        ${plan4Years()}
      `;

    case 6:
      // 🟢 499 + 899
      return `
        ${view_css_plan()}
        ${planAnual()}
        ${plan4Years()}
      `;

    default:
      console.warn("payments_accepted desconocido:", payments_accepted);
      return `
        ${view_css_plan()}
        ${planBimestral()}
        ${planAnual()}
      `;
  }
}


window.login = login;
window.viewLogin = viewLogin;
window.viewForgot = viewForgot;

// 👇 puente legacy HTML → módulos
window.loginUser = loginUser;
window.forgotPassword = forgotPassword;